import * as React from 'react';
import { connect } from 'react-redux';
import FilesTable from './FilesTable';
import { Dispatch, } from 'redux';
import { AppState } from '../../redux';
import {
    deleteRowbyId,
    onFilesChange2,
    saveMaterialType,
    saveTatType,
    saveDesignType,
    saveMessegeOrder,
    onClearAllFiles,
    onSelectFile,
    onSelectAllFile,
    saveManufactType,
    saveBranchType,
    saveDesignApproval,
    onUploadType,
    onClearAllUploaded,
    onRefreshStatus,
    saveDesignSoftware,
    saveOrderModel,
    saveIsBravo,
    saveDrPreferences,
    saveBookingId
} from 'src/actions/fileuploadAction';
import { onFileError2, handleCloseAlert, handleCloseRemovefiles } from 'src/actions/errorAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
    return {
        files2: state.fileUpload.files2,
        progress: state.fileUpload.progress,
        sending: state.fileUpload.sending,
        userDetails: state.user.userDetails,

        orderDataDesign: state.fileUpload.orderDataDesign,
        orderDataTat: state.fileUpload.orderDataTat,
        orderDataMaterial: state.fileUpload.orderDataMaterial,
        orderDataManufacturer: state.fileUpload.orderDataManufacturer,

        orderDataBranch: state.fileUpload.orderDataBranch,
        branchType: state.fileUpload.branchType,

        errorMessage: state.errorState.errorMessage,
        errorBar: state.errorState.errorBar,
        successMessage: state.errorState.successMessage,
        successBar: state.errorState.successBar,

        errorfilemsg: state.errorState.errorfilemsg,
        errorFileUploadedOpen: state.errorState.errorFileUploadedOpen,

        successFileUploadOpen: state.errorState.successFileUploadOpen,
        successfilemsg: state.errorState.successfilemsg,

    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onFilesChange2: function (files2: Array<File>) {
            dispatch(onFilesChange2(files2));
        },
        onFilesError2: function (error: Error, file2: Array<File>) {
            dispatch(onFileError2(error, file2));
        },
        deleteRowbyId: (event: React.ChangeEvent<{ value: string }>) => {
            dispatch(deleteRowbyId(event));
        },
        onUploadAllFiles: () => {
            dispatch(onUploadType);
        },
        onClearAllFiles: () => {
            dispatch(onClearAllFiles);
        },
        onRefreshStatus: () => {
            dispatch(onRefreshStatus);
        },
        onClearAllUploaded: () => {
            dispatch(onClearAllUploaded);
        },
        onSelectFile: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(onSelectFile(event));
        },
        onSelectAllFile: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(onSelectAllFile(event));
        },
        saveMaterialType: (event: string, index: number) => {
            dispatch(saveMaterialType(event, index));
        },
        saveTatType: (event: string, index: number) => {
            dispatch(saveTatType(event, index));
        },
        saveDesignType: (event: string, index: number) => {
            dispatch(saveDesignType(event, index));
        },
        saveManufactType: (event: string, index: number) => {
            dispatch(saveManufactType(event, index));
        },
        saveDesignSoftware: (event: string, index: number) => {
            dispatch(saveDesignSoftware(event, index));
        },
        saveOrderModel: (event: string, index: number) => {
            dispatch(saveOrderModel(event, index));
        },
        saveDesignApproval: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(saveDesignApproval(event));
        },
        saveIsBravo: (event: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(saveIsBravo(event));
        },
        saveBranchType: (branchType: string) => {
            dispatch(saveBranchType(branchType));
        },
        saveMessegeOrder: (event: string, index: number) => {
            dispatch(saveMessegeOrder(event, index));
        },
        handleClose: () => {
            dispatch(handleCloseAlert);
        },
        handleCloseRemovefiles: () => {
            dispatch(handleCloseRemovefiles);
        },
        onComponentDidMount: () => {
            dispatch(saveBranchType('General'));
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
        },
        saveDrPreferences: (event: string, index: number) => {
            dispatch(saveDrPreferences(event, index));
        },
         saveBookingId: (event: string, index: number) => {
            dispatch(saveBookingId(event, index));
        },
    };
};

const FilesTableContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FilesTable);

export default FilesTableContainer;



// WEBPACK FOOTER //
// ./src/components/filesTable/FilesTableContainer.tsx